import { render, staticRenderFns } from "./InformationSection.vue?vue&type=template&id=dcc882f4"
import script from "./InformationSection.vue?vue&type=script&lang=ts"
export * from "./InformationSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcc882f4')) {
      api.createRecord('dcc882f4', component.options)
    } else {
      api.reload('dcc882f4', component.options)
    }
    module.hot.accept("./InformationSection.vue?vue&type=template&id=dcc882f4", function () {
      api.rerender('dcc882f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inforationCards/InformationSection.vue"
export default component.exports